import * as actions from "./timetravel.actions.actions";

let initialState = {
  currentTime: undefined,
  path: { url: "" },
};

function timeTravelReducer(state = initialState, action) {
  switch (action.type) {
    case actions.TIME_TRAVEL_GET_DATE_SUCCESS:
      return Object.assign({}, state, {
        currentTime: action.response,
      });

    case actions.TIME_TRAVEL_SET_DATE_SUCCESS:
      return Object.assign({}, state, {
        currentTime: action.additionalData,
      });

    case actions.BE_ADMIN_URL_CHANGE:
      return Object.assign({}, state, {
        path: { url: action.path },
      });

    default:
      return state;
  }
}

export default timeTravelReducer;
